'use strict';

import util from '../../util';
import analytics from '../../analytics';
import crossSellTabs from './../cross_sell_tabs';
/**
 * @description Creates product recommendation carousel using Slick carousel
 **/

// Slick's built-in arrows are accessible (aria-label, type="button"); custom markup must replicate that
var accessibleArrows = {
	nextArrow: '<div class="slick-btn-wrapper"><button type="button" class="slick-next" aria-label="Next slide"><span class="next" aria-hidden="true"></span></button></div>',
	prevArrow: '<div class="slick-btn-wrapper"><button type="button" class="slick-prev" aria-label="Previous slide"><span class="prev" aria-hidden="true"></span></button></div>'
};

// Gives slick's numbered dot buttons an accessible name for screen readers
function accessibleDotPaging(slider, i) {
	return $('<button type="button" aria-label="Go to slide ' + (i + 1) + '"></button>').text(i + 1);
}

var carouselReccomendations = function(){
	if ($('#recommendation-slick-carousel .carousel-recommendations').length > 0) {
		var recommendationCarousel = $('#recommendation-slick-carousel .carousel-recommendations');
		var recommendationSlickCarousel = $('#recommendation-slick-carousel');
		var recommendationCarouselItem = recommendationCarousel.find('.recommendation-item');

		var slideCount;
		if($(".pt_cart").length) {
			slideCount = 3;
		} else {
			slideCount = 5;
		}
		if($(".cart-action-continue-shopping").length && !$(".cart_page").length) {
			slideCount = 5;
		}

		if ($(window).width() >= 1024 && recommendationCarouselItem.length <= slideCount && !$(".pt_cart").length) {
            recommendationCarouselItem.addClass('variation-width');
        }
		
		if ($(window).width() >= 1024 && recommendationCarouselItem.length > slideCount) {
			recommendationCarousel.not('.slick-initialized').slick({
				dots: false,
				infinite: false,
				speed: 300,
				slidesToShow: slideCount,
				slidesToScroll: slideCount,
				nextArrow: accessibleArrows.nextArrow,
				prevArrow: accessibleArrows.prevArrow
			});
		}
		if(!recommendationSlickCarousel.parent('.recommendation-redesign').length) {
			if ($(window).width() >= 768 && $(window).width() < 1024 && recommendationCarouselItem.length > 3) {
				recommendationCarousel.not('.slick-initialized').slick({
					dots: false,
					infinite: false,
					speed: 300,
					slidesToShow: 3,
					slidesToScroll: 3,
					nextArrow: accessibleArrows.nextArrow,
					prevArrow: accessibleArrows.prevArrow
				});
			}
			if ($(window).width() > 480 && $(window).width() < 768 && recommendationCarouselItem.length > 2) {
				recommendationCarousel.not('.slick-initialized').slick({
					dots: true,
					customPaging: accessibleDotPaging,
					infinite: false,
					speed: 300,
					slidesToShow: 2,
					slidesToScroll: 2,
					nextArrow: accessibleArrows.nextArrow,
					prevArrow: accessibleArrows.prevArrow
				});
			}
			if ($(window).width() < 480 && recommendationCarouselItem.length > 1) {
				recommendationCarousel.not('.slick-initialized').slick({
					slidesPerRow: 2,
					rows: 2,
					dots: true,
					customPaging: accessibleDotPaging,
					infinite: false,
					speed: 300,
					nextArrow: accessibleArrows.nextArrow,
					prevArrow: accessibleArrows.prevArrow
				});
			}   
		}
		$('.slick-arrow').on('click', function(e){
			e.preventDefault();
		});
	}
}

var initPLPSlider = function() {
	// for each loop to initialize slider
	var isDesktop = window.matchMedia("(min-width: 1025px)").matches;
	if(isDesktop) {
		$('.carousel-recommendations .product-slick-track').each(function () {
			var slider = $(this);
			if(!$(this).hasClass("slick-initialized")) {
				$(slider).slick({
					initialSlide: 0,
					autoplay: false,
					dots: false,
					arrows: true,
					infinite: false,
					speed: 150,
					slidesToShow: 1,
					fade: true,
                	cssEase: 'linear',
					customPaging: accessibleDotPaging,
					responsive: [
						{
							breakpoint: 1024,
							settings: {
							arrows: false,
							dots: true,
							}
						}
					]
				});
			}// Initialize the Slick slider
			
			var timer;
			var manualNavigation = false;

			$(slider).on({
				/**
				 * If the user has not manually navigated, shows the second slide after a delay.
				 *
				 */
				mouseenter: function () {
					clearTimeout(timer);

					// If the user has not manually navigated, show the second slide
					if (manualNavigation !== true && isDesktop) {
						var currentIndex = slider.slick('slickCurrentSlide');
						if (currentIndex !== undefined) {
							timer = setTimeout(function () {
								if (currentIndex === 0) { // If the current slide is the first slide
									slider.slick('slickGoTo', 1); // Show the second slide
								}
							}, 100);
						}
					}
				},
				mouseleave: function () {
					clearTimeout(timer);
					// If the user has not manually navigated, revert to the first slide
					if (manualNavigation !== true && isDesktop) {
						var currentIndex = slider.slick('slickCurrentSlide');
						if (currentIndex !== undefined) {
							timer = setTimeout(function () {
								if (currentIndex !== 0) { // If the current slide is not the first slide
									slider.slick('slickGoTo', 0); // Show the first slide
								}
							}, 100);
						}
					}
				}
			});
			/**
			 * Sets a flag to indicate that the user has manually navigated the slider.
			 * This is triggered when the user clicks on a slider arrow.
			*/
			$(slider).find('.slick-arrow').on('click', function(e) {
				if ($(this).length) { // Check if the element exists
					manualNavigation = true; // Set manual navigation flag
				}
			});
			$(slider).find('.slick-next').on('click', function(e) {
				e.stopPropagation();
				e.preventDefault();
			});
			$(slider).find('.slick-prev').on('click', function(e) {
				e.stopPropagation();
				e.preventDefault();
			});
		});
	}
}

var storedetailRelatedProducts = function (){
	   var $storedetailcarousel = $('.store-image-cont').not('.slick-initialized');
	    if (!$storedetailcarousel ||$storedetailcarousel.length === 0 || $storedetailcarousel.children().length === 0) {
	        return;
	    }
	    
	    $storedetailcarousel.slick({
	    	slidesToShow: 1,
			slidesToScroll: 1,
			infinite: true,
			dots: true,
			customPaging: accessibleDotPaging,
			responsive: [
				{
				    breakpoint: 9999,
		            settings: "unslick"
			    },
			{
			      breakpoint: 768,
			      settings: {
			    	slidesToShow: 1,
					slidesToScroll: 1,
					infinite: true,
					dots: true
			      }
			    }
			    
			]
	    });
};

var mobileOnlyCarouselReccomendations = function (){
	if(!$('.howto-detail-page').length){
		var $mobileonlyCarousel = $('.mobile-carousel-reccomendations'),
			isInitialized = false;
		if (!$mobileonlyCarousel ||$mobileonlyCarousel.length === 0 || $mobileonlyCarousel.children().length === 0) {
			return;
		}
		
		// to initialize only once when slider visible to view port
		if(!isInitialized) {
			$mobileonlyCarousel.slick({
				slidesToShow: 1,
				slidesToScroll: 1,
				infinite: true,
				dots: true,
				customPaging: accessibleDotPaging,
				
				responsive: [
					{
						breakpoint: 9999,
						settings: "unslick"
					},
				{
					breakpoint: 768,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1,
						infinite: true,
						dots: true
					}
					}
					
				]
			});
		}

		// init method fires after first initialization.
		$mobileonlyCarousel.on('init', function(event, slick){
			isInitialized = true;
		});
	}
};

var storeDetailSlider = function (){
	var $carousel = $('.store-image-slides').not('.slick-initialized');
	if ( $carousel.length === 0 || $carousel.children().length === 0) {
		return;
	}

	$carousel.slick({
		infinite: true,
		slidesToShow: 1,
		slidesToScroll: 1,
		slide: 'li',
		dots: true,
		customPaging: accessibleDotPaging,
		responsive: [{
			breakpoint: 768,
			settings: {
				arrows: false
			}
		}]
	});
};

// initialize recommendation slick slider, only when scroll reach to that section
function recommendationObserver() {
	if ($('#recommendation-slick-carousel').length > 0) {
		var targetElement = document.getElementById('recommendation-slick-carousel');
		var options = {
				root: null,
				rootMargin: ('0px'),
				threshold: 1.0
			};
		
		if(typeof(targetElement) != 'undefined' && targetElement != null && !!window.IntersectionObserver) {
			var observer = new IntersectionObserver(recommendationObserverHandler);
			observer.observe(targetElement);
		}
	}
}

function recommendationObserverHandler(entries, observer) {
	if ($('#recommendation-slick-carousel').length > 0) {
		var targetElement = document.getElementById('recommendation-slick-carousel');

		for (var entry of entries) {
			if (entry.isIntersecting && entry.target.id === targetElement.id) {	
				carouselReccomendations();
				if(!window.SitePreferences.ENABLE_SINGLE_TILE_IMAGE) {
					initPLPSlider();
				}
				mobileOnlyCarouselReccomendations();
			}
		}
	}
	
}

function polyfillIntersectionObserver() {
	// check browser supports IntersectionObserver or not
	if (!!window.IntersectionObserver) {
		recommendationObserver();
	} else {
		// excuted if browser not supports IntersectionObserver
		carouselReccomendations();
		if(!window.SitePreferences.ENABLE_SINGLE_TILE_IMAGE) {
            initPLPSlider();
        }
		mobileOnlyCarouselReccomendations();
	}	
}

// Recommendation Redesign Mobile carousel initialization 
function recommendationRedesign() {
	if($('.recommendation-redesign').length && $(window).width() < 991) {
		var recommendationSelector = $('.recommendation-redesign .carousel-recommendations');

		$('.recommendation-redesign').closest('.recommendation-block').addClass('re-minheight');
		$('.recommendation-redesign').closest('.container').addClass('rec-no-padding');

		// OverlayScrollbars initialization with an element
		recommendationSelector.each(function (index, ele) {
			// run OverlayScrollbars initialization for each recommendation carousel element which are present in the DOM and more then two
			if ($(ele).find('li').length <= 2) {
				return; // Skip initialization if there are 2 or fewer items
			}
			var osInstance = OverlayScrollbars($(ele), {});
		});
		if($(".plp-cross-sell").length) {
			const $element = $(".plp-cross-sell");
			const $tileLength = $element.find(".os-content li").length;
			if($tileLength == 2) {
				$element.find(".os-content").addClass("left-os-content");
			} else {
				$element.find(".os-content").removeClass("left-os-content");
			}
		}
	} else {
		var recommendationSelector = $('.recommendation-redesign .carousel-recommendations');
		recommendationSelector.each(function (index, ele) {
			var osInstance = OverlayScrollbars($(ele), {}).destroy(); // Disable for desktop screen
		});
	}
	var isDesktop = window.matchMedia("(min-width: 1025px)").matches;
	if(!isDesktop && $(".cart-body").length) {
		if($("ul.carousel-recommendations .os-content li.grid-tile").length < 2 && !$(".cart_page").length) {
			$('div[id^="cq_recomm_slot"]').css("width", "100%")
		}
	}
}

function screenResizeHandler() {
	// Store the window width
    var winWidth = $(window).width();

	$(window).on('resize orientationchange', function () {
		// to prevent calling of resize event in IOS devices while scrolling
        if ($(window).width() != winWidth) {
            // Update the window width for next time
            winWidth = $(window).width();            
			// Do stuff here
			if ($('#recommendation-slick-carousel').length > 0) {
				var $recommendationCarousel = $('#recommendation-slick-carousel .carousel-recommendations');			
				if ($recommendationCarousel.hasClass('slick-initialized')) {
					$recommendationCarousel.slick('destroy');
					carouselReccomendations();
					if(!window.SitePreferences.ENABLE_SINGLE_TILE_IMAGE) {
						initPLPSlider();
					}
				}
			}
        }
	});
}

function crosssellRecommendationModal() {
	const $modal = $('.crosssell-recommendation-modal');
	if ($modal.length === 0) {
		return;
	}

	util.waitForElement('.crosssell-recommendation-modal .carousel-recommendations').then(function ($recommendations) {
		const $productSlickTrack = $('.crosssell-recommendation-modal .product-slick-track');
		
		if ($('.minicart-link').hasClass('minicart-open')) {
			analytics.gymSharkCrossSellafterInit($modal.find('.carousel-recommendations'));
			// Fix: trigger slick to recalculate widths after modal is visible
			setTimeout(function () {
				if ($recommendations && $recommendations.hasClass('slick-initialized')) {
					$recommendations.slick('setPosition');

					$productSlickTrack.each(function () {
						if ($(this).hasClass('slick-initialized')) {
							$(this).slick('setPosition');
						}
					});
				}
			}, 100); // slight delay to ensure visibility
		}
		
		if (
			$recommendations &&
			!$recommendations.hasClass('slick-initialized') &&
			$(window).width() > 767 &&
			$recommendations.find('.recommendation-item').length > 3
		) {
			$recommendations.slick({
				initialSlide: 0,
				autoplay: false,
				dots: false,
				arrows: true,
				infinite: false,
				speed: 150,
				slidesToShow: 3,
				slidesToScroll: 3,
				fade: false,
				cssEase: 'linear',
				nextArrow: accessibleArrows.nextArrow,
				prevArrow: accessibleArrows.prevArrow,
			});

			// Also call setPosition after initialization
			setTimeout(function () {
				if ($recommendations.hasClass('slick-initialized')) {
					$recommendations.slick('setPosition');
				}
			}, 100);
		}

		// Initialize PLP slider for cross-sell products
		if(!window.SitePreferences.ENABLE_SINGLE_TILE_IMAGE) {
            initPLPSlider();
        }
		
		setTimeout(function () {
			$productSlickTrack.each(function () {
				if ($(this).hasClass('slick-initialized')) {
					$(this).slick('setPosition');
				}
			});
		}, 100);

	});
}

const shoppableProductCarouselRecommendations = () => {
	// component id repeats per instance, so every lookup must be scoped to its own wrapper
	const $wrappers = $('.shoppable-product-carousel-wrapper');

	if (!$wrappers.length) return;

	const getSliderConfig = ($items) => {
		const width = window.innerWidth;
		const visibleItems = width < 1024 ? 3 : 4;

		return {
			enabled: $items.length > visibleItems,
			settings: {
				slidesToShow: visibleItems,
				slidesToScroll: visibleItems,
				dots: false,
				infinite: false,
				speed: 300,
				...accessibleArrows
			}
		};
	};

	const initializeSlider = ($wrapper) => {
		const $carousel = $wrapper.find('#content-related-products-carousel .carousel-recommendations');
		const $carouselContainer = $wrapper.find('#content-related-products-carousel');
		const $items = $carousel.find('.recommendation-item');
		const isRedesign = $carouselContainer.parent('.recommendation-redesign').length;
		const { enabled, settings } = getSliderConfig($items);

		// Remove desktop width helper class first
		$items.removeClass('variation-width');

		if (!enabled) {
			if (window.innerWidth >= 1024 && $items.length <= 4) {
				$items.addClass('variation-width');
			}

			if ($carousel.hasClass('slick-initialized')) {
				$carousel.slick('unslick');
			}

			return;
		}

		// Skip tablet/mobile carousel for redesign layout if required
		if (
			isRedesign &&
			window.innerWidth < 1024
		) {
			return;
		}

		if (!$carousel.hasClass('slick-initialized')) {
			$carousel.slick(settings);
		}
	};

	// Initial load, run independently per instance
	$wrappers.each(function () {
		initializeSlider($(this));
	});

	// Responsive reinitialization
	let resizeTimer;

	$(window).on('resize', () => {
		clearTimeout(resizeTimer);

		resizeTimer = setTimeout(() => {
			$wrappers.each(function () {
				const $wrapper = $(this);
				const $carousel = $wrapper.find('#content-related-products-carousel .carousel-recommendations');

				if ($carousel.hasClass('slick-initialized')) {
					$carousel.slick('unslick');
				}

				initializeSlider($wrapper);
			});
		}, 200);
	});

	$('body').on('click', '.slick-arrow', e => {
		e.preventDefault();
	});
};

var recommendations = {
    init: function() {
		crossSellTabs.init();
		screenResizeHandler();
		polyfillIntersectionObserver();
		storedetailRelatedProducts();
		storeDetailSlider();
		recommendationRedesign();
		shoppableProductCarouselRecommendations();
	},
	crosssellRecommendationModal: crosssellRecommendationModal
}

$(window).on('resize orientationchange', function () {
	recommendationRedesign();
	carouselReccomendations();
	if(!window.SitePreferences.ENABLE_SINGLE_TILE_IMAGE) {
		initPLPSlider();
	}
	crosssellRecommendationModal();
});

export default recommendations;